/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsCostBatchResponse {
    getFixupPrototypeFunction() { return AIUnitEconomicsCostBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsCostBatchResponse>): AIUnitEconomicsCostBatchResponse {
        let obj = Object.assign(new AIUnitEconomicsCostBatchResponse(), model);
        AIUnitEconomicsCostBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsCostBatchResponse>): AIUnitEconomicsCostBatchResponse {
        if (!model) return null;
        return AIUnitEconomicsCostBatchResponse.newInstance(<AIUnitEconomicsCostBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsCostBatchResponse) {
        if (!obj) return;

        models.AIUnitEconomicsCostBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsCostBatchResponse): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsCostBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AIUnitEconomicsCostRecord.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AIUnitEconomicsCostRecord; };

}
